import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {DocumentsService} from "../../../../../services/document.service";
import {UtilsService} from "../../../../../services/utils.service";
import {environment} from "../../../../../../environments/environment";
import {NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'app-progreso-cliente',
  standalone: true,
  imports: [
    NgForOf,
    NgIf
  ],
  templateUrl: './progreso-cliente.component.html',
  styleUrl: './progreso-cliente.component.css'
})
export class ProgresoClienteComponent implements OnInit, OnChanges{

  @Input({required: true}) userInfo: any;
  @Input({required: true}) detallePrograma: any;
  @Input({required: true}) detalleCliente: any;

  @Output() programaActualizado = new EventEmitter<void>(); // Emitirá un evento cuando se actualice

  listaProgresoDias: any;
  fechaFormateada: any
  fechaTimeStamp: any
  filtroFrente: boolean = true
  soloFotos: boolean = false
  listaProgresoDiasFiltrado: any = [];
  listaProgresoMostrar: any = [];

  constructor(private documentService: DocumentsService,
              private utilsService: UtilsService) {
  }

  ngOnInit(): void {

  }
  ngOnChanges(changes: SimpleChanges): void {
    this.filtroFrente = true
    this.soloFotos = false
    this.getProgresoCliente()
    this.obtieneFechaActual()
  }

  getProgresoCliente(){
    this.listaProgresoDias = []
    this.documentService.getAttachmentByType(environment.businessId, this.detalleCliente.documentId, 'progresoCliente').subscribe((res: any) => {

      let arrSort: any = []
      arrSort= res.content

      arrSort = arrSort.sort((a, b) => a.timestamp - b.timestamp);

      this.listaProgresoDias = arrSort
      this.listaProgresoDiasFiltrado = []
      for(let x in this.listaProgresoDias){
        let day = ['Dom', 'Lun', 'Mar', 'Mier', 'Jue', 'Vie', 'Sab'][new Date(this.listaProgresoDias[x].timestamp*1000).getDay()]
        let month = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sept', 'Oct', 'Nov', 'Dic'][new Date(this.listaProgresoDias[x].timestamp*1000).getMonth()]

        this.listaProgresoDias[x].diaLetra = day;
        this.listaProgresoDias[x].mesLetra = month;

        if(this.listaProgresoDias[x].fotoFrente != ''){
          this.listaProgresoDiasFiltrado.push(this.listaProgresoDias[x]);
        }
      }

      this.listaProgresoMostrar = this.listaProgresoDias

    }, err => {
      console.error(err)
    })
  }

  obtieneFechaActual(){
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm: any = today.getMonth() + 1; // Months start at 0!
    let dd: any = today.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    const formattedToday = dd + '-' + mm + '-' + yyyy;
    this.fechaFormateada = formattedToday;

    let myDate: any = formattedToday;
    myDate = myDate.split("-");
    let newDate = new Date( myDate[2], myDate[1] - 1, myDate[0]);

    const dateTimestamp = (newDate.getTime() / 1000) + 28800
    this.fechaTimeStamp = dateTimestamp
  }

  filtroFrenteFn(val){
    this.filtroFrente = val
  }

  onCheckboxChange(event: any){
    if(event.target.checked){
      this.listaProgresoMostrar = this.listaProgresoDiasFiltrado
    }else{
      this.listaProgresoMostrar = this.listaProgresoDias
    }
  }

}
